import React, { useEffect, useState } from 'react';
import IncidentNavigationBar from './IncidentNavigationBar';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

const CmdbPage = () => {
  const [spec, setSpec] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/config.json')
      .then(res => res.json())
      .then(config => {
        const baseUrl = config.API_BASE_URL;
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const domain = isLocalhost && config.DOMAIN
          ? config.DOMAIN.replace("https://", "").replace("http://", "").replace("-api-explorer", "")
          : window.location.hostname.replace('https://', '').replace('http://', '').replace('-api-explorer', '');
        return fetch(`${baseUrl}wolken-secure/openapi/itsm/cmdb`, { credentials: 'include', headers: { domain } });
      })
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch OpenAPI spec');
        return res.json();
      })
      .then(json => {
        setSpec(json);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <IncidentNavigationBar />
      <div id="content-div" style={{ marginTop: '2rem' }}>
        {loading ? (
          <div style={{ textAlign: 'center', marginTop: '2rem', fontSize: '1.2rem' }}>Loading API documentation...</div>
        ) : error ? (
          <div style={{ color: 'red', textAlign: 'center', marginTop: '2rem' }}>Error: {error}</div>
        ) : (
          <SwaggerUI spec={spec} />
        )}
      </div>
    </>
  );
};

export default CmdbPage;
